export const environment = {
  production: true,
  Agent_Appeal_Url: '/Content/Appeal_Files/',
  iArRcmUrl : 'http://172.30.52.25:1001/',
  iDecisionTreeURL: 'https://www.gebbsiar.com/DecisionTree/Login.aspx',
  Encryptionkey:'IAR@gebbs_887887',
  version: 6.1,
  azureTicketApiUrl: 'https://utl.ircmsuite.com/AzureDevOpsWorkItemApi/api/',
  gebbsServiceDesk: 'https://utl.ircmsuite.com/Gebbs-Service-Desk/',
  clientInfo_clientIp: 'https://utl.ircmsuite.com/web-notification-api/api/ClientInfo/client-ip',

  // LIVE Server
  // ApiUrl: "http://172.18.7.2:1001/", // LIVE Server,
  // FileApiUrl: "http://172.18.7.2:1007/",// LIVE Server,
  // linkUsed: '172.18.7.2:1002'

  // New Server Internal
  // ApiUrl: "http://172.18.4.181:1001/", // LIVE Server,
  // FileApiUrl: "http://172.18.4.181:1007/",// LIVE Server,
  // linkUsed: '172.18.4.181:1002'

  // FileApiUrl: "https://iar.gebbsrcm.com:1003/",
  // ApiUrl: "https://iar.gebbsrcm.com:1001/",
  // linkUsed: 'https://iar.gebbsrcm.com:1001/'



  //New UAT Links:
  FileApiUrl: "https://iar.gebbsrcm.com:1003/",
  ApiUrl: "https://iar.gebbsrcm.com:1001/",
  linkUsed: 'https://iar.gebbsrcm.com:1001/'
};
///gebbs 192.168.30.28:1001 - webapp, 192.168.30.28:1007 , db username and pass : - iARProject

